import { useTranslation } from "react-i18next";

function PricingHeader() {
  const {t} = useTranslation("global")
  return (
  <section className="py-16 bg-gradient-to-b from-blue-800 to-blue-900 text-white">
    <div className="container mx-auto px-4">
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-6">
        {t("home.plan")}<span className="text-blue-300">  {t("home.tarif")}</span>
        </h1>
        <p className="text-xl text-blue-100 mb-8">
        {t("home.pricingHeader")}
        </p>
        <div className="w-20 h-1 bg-blue-300 mx-auto"></div>
      </div>
    </div>
  </section>
  );
}

export default PricingHeader;
